export const setupGlobalErrorHandlers = () => {
    window.addEventListener('unhandledrejection', (event) => {
        event.preventDefault();
        console.error('Unhandled promise rejection:', event.reason);
        if (event.reason?.message) {
            console.error('Error message:', event.reason.message);
        }
    });
    window.addEventListener('error', (event) => {
        console.error('Global error:', event.error || event.message);
        if (event.error?.name !== 'ChunkLoadError') {
            event.preventDefault();
        }
    });
};
